/* globals document, window */
import React from "react";
import { hydrate } from "react-dom";
import { BrowserRouter, withRouter } from "react-router-dom";

import ListingSearch from "./ListingSearch";

/* Render listing-detail app into the pug template, pulling props from global window */
function render(props) {
  const Component = withRouter(ListingSearch);
  hydrate(
    <BrowserRouter>
      <Component {...props} />
    </BrowserRouter>,
    document.getElementById("react")
  );
}
render(window.reactProps);
